import { render, staticRenderFns } from "./CommunicationBots.vue?vue&type=template&id=1a997c7a&"
import script from "./CommunicationBots.vue?vue&type=script&lang=js&"
export * from "./CommunicationBots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports